<script setup>
import {APIService} from '@/core/util/services/api.service';
import {onBeforeMount} from 'vue';
import {inject, ref, defineProps} from 'vue';
import OxdLabel from '@ohrm/oxd/core/components/Label/Label.vue';

const $toast = inject('$toast');
const http = new APIService(window.appGlobal.baseUrl, '');
const props = defineProps({
  id: Number,
});

const isLoading = ref(false);
const qualificationForm = ref({
  status: {id: '', label: ''},
  remarks: '',
  employeeSignature: {label: '', path: ''},
  managerSignature: {label: '', path: ''},
});

const isEmpty = value => {
  return value == '' || value == null || value == undefined;
};

const exportPdf = () => {
  window.open(
    `${window.appGlobal.publicPath}/api/onboarding/${props.id}/qualification_pdf`,
  );
};

const getQualificationData = () => {
  isLoading.value = true;
  http
    .request({
      method: 'GET',
      url: `/api/onboarding/${props.id}/qualification`,
    })
    .then(response => {
      if (!isEmpty(response.data)) qualificationForm.value = response.data;
    })
    .catch(error => {
      $toast.unexpectedError();
    })
    .finally(() => {
      isLoading.value = false;
    });
};

const openFile = path => {
  window.open(`${window.appGlobal.publicPath}/${path}`, '_blank');
};

onBeforeMount(() => {
  getQualificationData();
});
</script>
<template>
  <div style="text-align:right">
    <oxd-button
      label="Export"
      icon-name="file-pdf"
      display-type="secondary"
      @click="exportPdf()"
    />
  </div>
  <div class="orangehrm-background-container">
    <oxd-form :loading="isLoading">
      <oxd-form-row>
        <oxd-grid :cols="3" class="orangehrm-full-width-grid">
          <oxd-grid-item>
            <oxd-input-field
              label="Qualification Status"
              :value="qualificationForm.status?.label"
              :disabled="true"
            />
          </oxd-grid-item>
          <oxd-grid-item class="--span-column-2">
            <oxd-input-field
              :value="qualificationForm.remarks"
              type="textarea"
              label="Remarks"
              placeholder="Remarks"
              :disabled="true"
            />
          </oxd-grid-item>
        </oxd-grid>
      </oxd-form-row>
      <oxd-form-row>
        <oxd-grid :cols="2">
          <oxd-grid-item>
            <OxdLabel label="Co-worker signature" />
            <div class="flex gap-3 items-center" style="margin-top: 10px">
              <oxd-icon-button
                :disabled="isEmpty(qualificationForm.employeeSignature?.path)"
                name="download"
                @click="openFile(qualificationForm.employeeSignature?.path)"
              />
              <OxdLabel
                v-if="!isEmpty(qualificationForm.employeeSignature?.path)"
                :label="
                  qualificationForm.employeeSignature?.label ??
                    qualificationForm.employeeSignature?.path
                "
              />
              <OxdLabel v-else label="No co-worker signature found." />
            </div>
          </oxd-grid-item>
          <oxd-grid-item>
            <OxdLabel label="Manager signature" />
            <div class="flex gap-3 items-center" style="margin-top: 10px">
              <oxd-icon-button
                :disabled="isEmpty(qualificationForm.managerSignature?.path)"
                name="download"
                @click="openFile(qualificationForm.managerSignature?.path)"
              />
              <OxdLabel
                v-if="!isEmpty(qualificationForm.managerSignature?.path)"
                :label="
                  qualificationForm.managerSignature?.label ??
                    qualificationForm.managerSignature?.path
                "
              />
              <OxdLabel v-else label="No manager signature found." />
            </div>
          </oxd-grid-item>
        </oxd-grid>
      </oxd-form-row>
    </oxd-form>
  </div>
</template>
